module.exports = __webpack_public_path__ + "static/media/my-colcers-icon.62fb74f1.svg";